import { render } from "./index.vue?vue&type=template&id=f3a85fa2&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts&setup=true"
export * from "./index.vue?vue&type=script&lang=ts&setup=true"

import "./index.vue?vue&type=style&index=0&id=f3a85fa2&scoped=true&lang=less"

import exportComponent from "/home/runner/work/smanga/smanga/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3a85fa2"],['__file',"src/views/test/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f3a85fa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f3a85fa2', __exports__)) {
    console.log('reload')
    api.reload('f3a85fa2', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=f3a85fa2&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('f3a85fa2', render)
  })

}


export default __exports__